import { Card, Row, Col, Statistic, Typography } from "antd";

const { Title } = Typography;

const formatCurrency = (value) => {
  if (value !== undefined && value !== null) {
    return `₹${value.toLocaleString("en-IN")}`;
  }
  return "₹0";
};

const SalesStatistics = ({ stats }) => {
  const {
    totalAmount,
    dailyAverageAmount,
    averageTicketPrice,
    dailyAverageCount,
    totalPaymentsCount,
    bundledCount,
    individualCount,
    discountedPaymentsCount
  } = stats || {};

  return (
    <>
      <Title level={3}>Sales Statistics</Title>
      <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card>
            <Statistic
              title="Total Revenue"
              value={totalAmount}
              precision={2}
              formatter={(value) => formatCurrency(value)}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card>
            <Statistic
              title="Daily Avg. Revenue"
              value={dailyAverageAmount}
              precision={2}
              formatter={(value) => formatCurrency(value)}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card>
            <Statistic
              title="Average Ticket Price"
              value={averageTicketPrice}
              formatter={(value) => formatCurrency(value)}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card>
            <Statistic title="Daily Avg. Payments" value={dailyAverageCount} precision={2} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card>
            <Statistic title="Total Payments" value={totalPaymentsCount} />
          </Card>
        </Col>
        {bundledCount > 0 && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <Card>
              <Statistic
                title="Bundled Payments"
                value={bundledCount}
                suffix={`/ ${totalPaymentsCount}`}
              />
            </Card>
          </Col>
        )}
        {individualCount > 0 && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <Card>
              <Statistic
                title="Individual Payments"
                value={individualCount}
                suffix={`/ ${totalPaymentsCount}`}
              />
            </Card>
          </Col>
        )}
        {discountedPaymentsCount > 0 && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <Card>
              <Statistic
                title="Discounted Payments"
                value={discountedPaymentsCount}
                suffix={`/ ${totalPaymentsCount}`}
              />
            </Card>
          </Col>
        )}
      </Row>
    </>
  );
};

export default SalesStatistics;
